import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetRelationTypes = () => {
    const {
        isFetching: isLoading, data: relationships, error,
    } = useQuery({
        queryKey: ["Relationships"],
        queryFn: () => axiosManager.get$("/parent/api/Relationships").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const relationshipsOptions = (relationships || [])
        .map((item) => ({ value: item.relationshipTypeId, label: item.displayName }));

    return {
        isLoading,
        relationships,
        error,
        relationshipsOptions,
    };
};
